import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class SpecialEducation extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Special Education</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Special Education</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Special Education</h2>

                      <p>
                        At Shakuntla Learn and Fly Foundation, we believe that every child has the
                        ability to learn, grow, and succeed when provided with the right guidance,
                        support, and opportunities. Our Special Education program is designed to meet
                        the unique educational and developmental needs of children with developmental
                        delays, learning disabilities, autism spectrum disorder, intellectual disabilities,
                        ADHD, Down syndrome, cerebral palsy, and other special needs.
                      </p>

                      <p>
                        Every child learns differently. Our experienced special educators develop Individualized
                        Education Plans (IEPs) based on comprehensive assessments, focusing on each
                        child's strengths, abilities, interests, and learning requirements. Through
                        structured teaching, multisensory instruction, activity-based learning, and
                        evidence-based educational practices, we create an inclusive environment
                        where children can thrive academically and personally.
                      </p>
                      <h3 className="section-space--top--50">Our Approach</h3>

                      <p>
                        We work closely with parents, caregivers, therapists, and schools to ensure
                        consistency in every child's learning journey. Family involvement
                        plays a vital role in reinforcing progress beyond the classroom.
                        Our goal is not only to improve academic performance but also to
                        build confidence, independence, self-esteem, and meaningful
                        participation in everyday life.
                      </p>
                      <h3 className="section-space--top--40">Conclusion</h3>

                      <p>
                        At Shakuntla Learn and Fly Foundation, we are committed to unlocking every
                        child's potential through compassionate care, individualized education,
                        and evidence-based teaching practices. By nurturing abilities,
                        encouraging independence, and celebrating every achievement,
                        we help children develop the confidence and skills they need
                        to thrive at home, in school, and within their communities.
                        Together with families, we strive to create a future where every
                        child can truly learn, grow, and fly.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default SpecialEducation;
